import React, { useState, useEffect } from "react";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import TableHead from "@mui/material/TableHead";
import "./CurrencyModalTable.scss";
import { getCurrencyDetails } from "../../../util/API/treasury";
// import CurrencyModal from "../CurrencyModal/CurrencyModal";

//pagination component
function CustomerTable(props) {
  const theme = useTheme();
  const { page, onPageChange, pageNumbers } = props;

  const handlePageClick = (event, pageNumber) => {
    onPageChange(event, pageNumber);
  };

  return (
    <Box
      sx={{
        flexShrink: 0,
        ml: 2.5,
        display: "flex",
        justifyContent: "space-between", // Center the page numbers
        alignItems: "center", // Center vertically
      }}
    >
      <div>
        <IconButton
          onClick={(event) => handlePageClick(event, page - 1)}
          disabled={page === 0}
          aria-label="previous page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowRight />
          ) : (
            <>
              <KeyboardArrowLeft />
              <span className="arrowLabelStyle">Previous</span>
            </>
          )}
        </IconButton>
      </div>
      <div>
        {pageNumbers.map((pageNumber, index) => {
          if (pageNumbers.length <= 5) {
            // If there are 5 or fewer pages, show all page numbers
            return (
              <span
                key={pageNumber}
                className={`page-number ${
                  pageNumber === page ? "active-page" : ""
                }`}
                onClick={(event) => handlePageClick(event, pageNumber)}
              >
                {pageNumber + 1}
              </span>
            );
          } else if (
            index === 0 ||
            index === pageNumbers.length - 1 ||
            Math.abs(index - page) <= 1
          ) {
            // Show the first, last, and adjacent page numbers to the selected page
            return (
              <span
                key={pageNumber}
                className={`page-number ${
                  pageNumber === page ? "active-page" : ""
                }`}
                onClick={(event) => handlePageClick(event, pageNumber)}
              >
                {pageNumber + 1}
              </span>
            );
          } else if (index === 1 || index === pageNumbers.length - 2) {
            // Show the second and second-to-last page numbers, and add ellipsis before and after
            return (
              <span key={pageNumber} className="ellipsis">
                ...
              </span>
            );
          }
          return null;
        })}
      </div>

      <div>
        <IconButton
          onClick={(event) => handlePageClick(event, page + 1)}
          disabled={page === pageNumbers.length - 1}
          aria-label="next page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowLeft />
          ) : (
            <>
              <span className="arrowLabelStyle">Next</span>
              <KeyboardArrowRight />
            </>
          )}
        </IconButton>
      </div>
    </Box>
  );
}

export default function CurrencyModalTable({ selectedCurrency }) {
  const [page, setPage] = useState(0);
  const [rowsPerPage] = useState(2);
  const [currencyData, setCurrencyData] = useState();
  const [loading, setLoading] = useState(true);

  //get curremcy data and set it to the state for the table
  useEffect(() => {
    const getCurrency = async () => {
      const response = await getCurrencyDetails();
      if (response.currencyData.length != undefined) {
        setCurrencyData(response.currencyData);
      } else {
        setCurrencyData([response.currencyData]);
      }
      setLoading(false);
    };
    getCurrency();
  }, []);

  let pageCount = Math.ceil(loading ? 0 : currencyData.length / rowsPerPage);
  let pageNumbers = Array.from({ length: pageCount }, (_, index) => index);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  return (
    <>
      <div className="currency-table-container">
        <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
          <Table sx={{ minWidth: 500 }} aria-label="custom pagination table">
            <TableHead>
              <TableRow>
                <TableCell
                  align="left"
                  style={{ width: 200, height: 33 }}
                  colSpan={1}
                  className="batch-table-headers grey-background"
                >
                  Transaction ID ({selectedCurrency.currency})
                </TableCell>
                <TableCell
                  align="left"
                  style={{ width: 250, height: 33 }}
                  className="batch-table-headers grey-background"
                  colSpan={1}
                >
                  Balance as of YYYY-MM-DD
                </TableCell>
                <TableCell
                  colSpan={3}
                  align="center"
                  className="batch-table-headers deposit-background"
                >
                  Deposits
                </TableCell>
                <TableCell
                  colSpan={3}
                  align="center"
                  className="batch-table-headers transfer-background"
                >
                  Transfers
                </TableCell>
                <TableCell
                  colSpan={2}
                  align="center"
                  className="batch-table-headers grey-background"
                >
                  Cash Forecasts
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  align="left"
                  style={{ width: 120 }}
                  className="batch-table-headers"
                ></TableCell>
                <TableCell
                  align="left"
                  style={{ width: 225 }}
                  className="batch-table-headers"
                ></TableCell>
                <TableCell
                  align="left"
                  style={{ width: 100 }}
                  className="batch-table-headers"
                >
                  Committed
                </TableCell>
                <TableCell
                  align="left"
                  style={{ width: 100 }}
                  className="batch-table-headers"
                >
                  Pending
                </TableCell>
                <TableCell
                  align="left"
                  style={{ width: 100 }}
                  className="batch-table-headers"
                >
                  Deposits
                </TableCell>
                <TableCell
                  align="left"
                  style={{ width: 100 }}
                  className="batch-table-headers"
                >
                  Committed
                </TableCell>
                <TableCell
                  align="left"
                  style={{ width: 100 }}
                  className="batch-table-headers"
                >
                  Pending
                </TableCell>
                <TableCell
                  align="left"
                  style={{ width: 100 }}
                  className="batch-table-headers"
                >
                  Deposits
                </TableCell>
                <TableCell
                  align="center"
                  style={{ width: 150 }}
                  className="batch-table-headers"
                >
                  Position
                </TableCell>
                <TableCell
                  align="left"
                  style={{ width: 100 }}
                  className="batch-table-headers"
                >
                  Status
                </TableCell>
              </TableRow>
            </TableHead>
            {loading ? (
              <></>
            ) : (
              <TableBody>
                {currencyData
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => (
                    <TableRow key={index}>
                      <TableCell
                        style={{ width: 120 }}
                        align="left"
                        className="batch-row-text"
                      >
                        {row.transactionId}
                      </TableCell>
                      <TableCell
                        style={{ width: 225 }}
                        align="left"
                        className="batch-row-text"
                      >
                        {row.dateAmount}
                      </TableCell>
                      <TableCell
                        style={{ width: 100 }}
                        align="left"
                        className="batch-row-text"
                      >
                        {row.depositsCommitted}
                      </TableCell>
                      <TableCell
                        style={{ width: 100 }}
                        align="left"
                        className="batch-row-text"
                      >
                        {row.depositsPending}
                      </TableCell>
                      <TableCell
                        style={{ width: 100 }}
                        align="left"
                        className="batch-row-text"
                      >
                        {row.depositsDeposit}
                      </TableCell>
                      <TableCell
                        style={{ width: 100 }}
                        align="left"
                        className="batch-row-text"
                      >
                        {row.transferCommitted}
                      </TableCell>
                      <TableCell
                        style={{ width: 100 }}
                        align="left"
                        className="batch-row-text"
                      >
                        {row.transfersDeposits}
                      </TableCell>
                      <TableCell
                        style={{ width: 100 }}
                        align="left"
                        className="batch-row-text"
                      >
                        {row.deposit2}
                      </TableCell>
                      <TableCell
                        style={{ width: 100 }}
                        align="left"
                        className="batch-row-text"
                      >
                        <div
                          className="position-pill"
                          style={{
                            background:
                              row.position > 0 ? "#3BC97B" : "#A92A36",
                          }}
                        >
                          {row.position}
                        </div>
                      </TableCell>
                      <TableCell
                        style={{ width: 100 }}
                        align="left"
                        className="batch-row-text"
                      >
                        <select className="currency-modal-select">
                          <option value="Pending">Pending</option>
                          <option value="Processing">Processing</option>
                          <option value="Committed">Committed</option>
                        </select>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            )}
          </Table>
          <div className="pagination-styling-batch">
            <CustomerTable
              page={page}
              onPageChange={handleChangePage}
              pageNumbers={pageNumbers}
            />
          </div>
        </TableContainer>
      </div>
    </>
  );
}
